import type { DashboardStatistics, DashboardStatisticsFilters } from '@partou/my-group/data';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap, throwError, timer } from 'rxjs';
import {
  MOCK_DASHBOARD_SCENARIOS,
  aggregateMockStatistics,
  getMockDashboardDelayMs,
  getMockDashboardLoadOutcome,
  getMockDashboardScenarioName,
} from '../constants/mock-dashboard.const';

@Injectable()
export class MockDashboardApiService {
  getStatistics(filters: DashboardStatisticsFilters): Observable<DashboardStatistics> {
    const delayMs: number = getMockDashboardDelayMs();
    const source: Observable<DashboardStatistics> =
      getMockDashboardLoadOutcome() === 'error'
        ? throwError((): Error => new Error('Failed to load dashboard statistics'))
        : of(aggregateMockStatistics(MOCK_DASHBOARD_SCENARIOS[getMockDashboardScenarioName()], filters));
    return delayMs > 0 ? timer(delayMs).pipe(switchMap((): Observable<DashboardStatistics> => source)) : source;
  }
}
